import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const Magazine = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Magazine" midBreadcrumb="Gallery" mainBreadcrumb="Magazine" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className='col-md-12'>
                        <h3 class="subhead">Magazines</h3>
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/cm.png" alt="matamariamjansevavidyalayas" className='img-fluid mx-auto d-block' />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Magazine
